import {
  AIEditSection,
  DASHLET_CONFIG,
} from 'components/Wizards/shared/components/AIEditSection';
import { buildDashletConfig } from 'pages/Dashboard/util';
import useShouldExpandModal from '../../hooks/useShouldExpandModal';

const buildConfigFromState = (state) => {
  if (!state?.area) return null;

  return {
    ...buildDashletConfig(state),
    name: state.name || '',
  };
};

const DashletAIEditSection = ({
  inModal,
  autoOpen = false,
  dashboardId,
  currentDashboard,
  isEditing,
  homepage,
}) => {
  const willModalExpand = useShouldExpandModal(currentDashboard);

  return (
    <AIEditSection
      inModal={inModal}
      autoOpen={autoOpen}
      isEditing={isEditing}
      homepage={homepage}
      buildConfigFromState={buildConfigFromState}
      willModalExpand={willModalExpand}
      entityConfig={DASHLET_CONFIG}
      dashboardId={dashboardId}
      oneShotOnly
    />
  );
};

export default DashletAIEditSection;
